(function () {
  'use strict';

  /* ---------------- Mobile nav ---------------- */
  var navToggle = document.getElementById('navToggle');
  var navLinks = document.getElementById('navLinks');
  var navScrim = document.getElementById('navScrim');
  function openMenu(){ navLinks.classList.add('open'); navScrim.classList.add('open'); navToggle.classList.add('open'); navToggle.setAttribute('aria-expanded','true'); document.body.style.overflow='hidden'; }
  function closeMenu(){ navLinks.classList.remove('open'); navScrim.classList.remove('open'); navToggle.classList.remove('open'); navToggle.setAttribute('aria-expanded','false'); document.body.style.overflow=''; }
  if (navToggle && navLinks && navScrim) {
    navToggle.addEventListener('click', function () { navLinks.classList.contains('open') ? closeMenu() : openMenu(); });
    navScrim.addEventListener('click', closeMenu);
    navLinks.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
    window.addEventListener('resize', function () { if (window.innerWidth > 860) closeMenu(); });
  }

  /* ---------------- Marquee ---------------- */
  document.querySelectorAll('.marquee-track[data-marquee-text]').forEach(function (track) {
    var raw = track.getAttribute('data-marquee-text') || '';
    var names = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var doubled = names.concat(names);
    track.innerHTML = doubled.map(function (n) { return '<span>' + n + '</span>'; }).join('');
  });

  /* ---------------- FAQ accordion ---------------- */
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentElement;
      var answer = item.querySelector('.faq-a');
      var isOpen = item.classList.contains('open');
      item.closest('.faq').querySelectorAll('.faq-item').forEach(function (i) {
        i.classList.remove('open');
        i.querySelector('.faq-a').style.maxHeight = null;
      });
      if (!isOpen) { item.classList.add('open'); answer.style.maxHeight = answer.scrollHeight + 'px'; }
    });
  });

  /* ---------------- Cart count (native Shopify AJAX Cart API) ---------------- */
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.nav-cart').forEach(function (el) {
          el.textContent = 'Cart (' + cart.item_count + ')';
        });
      })
      .catch(function () { /* non-fatal */ });
  }
  refreshCartCount();

  refreshCartCount();

  /* ---------------- Cart toast (global "added to cart" confirmation) ---------------- */
  var cartToastEl = document.getElementById('cartToast');
  var cartToastTimer = null;
  function showCartToast(message) {
    if (!cartToastEl) return;
    cartToastEl.textContent = message;
    cartToastEl.classList.add('show');
    if (cartToastTimer) clearTimeout(cartToastTimer);
    cartToastTimer = setTimeout(function () {
      cartToastEl.classList.remove('show');
    }, 3500);
  }
  window.showCartToast = showCartToast;

  /* ---------------- Category card click -> modal open ---------------- */
  // Event delegation on document: works no matter when the card elements
  // appear in the DOM, and doesn't depend on any other element (like the
  // modal overlay) existing at page-load time.
  function handleCategoryOpen(e) {
    var card = e.target.closest('[data-ttk-open-modal]');
    if (!card) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    if (e.type === 'keydown') e.preventDefault();
    var opened = false;
    if (typeof window.openTTKProductModal === 'function') {
      opened = window.openTTKProductModal(card.getAttribute('data-catalog'), card.getAttribute('data-ttk-open-modal'));
    }
    if (!opened) {
      var fallbackUrl = card.getAttribute('data-fallback-url');
      if (fallbackUrl) window.location.href = fallbackUrl;
    }
  }
  document.addEventListener('click', handleCategoryOpen);
  document.addEventListener('keydown', handleCategoryOpen);

  /* ---------------- Product quick-view modal ---------------- */
  var overlay = document.getElementById('productModalOverlay');
  if (!overlay) return; // page has no quick-view (e.g. checkout)

  var modalImage = document.getElementById('modalImage');
  var modalEyebrow = document.getElementById('modalEyebrow');
  var modalTitle = document.getElementById('modalProductTitle');
  var modalPrice = document.getElementById('modalPrice');
  var styleGrid = document.getElementById('styleGrid');
  var styleLabel = document.getElementById('styleLabel');
  var modalVariants = document.getElementById('modalVariants');
  var modalThumbs = document.getElementById('modalThumbs');
  var secondItemPicker = document.getElementById('secondItemPicker');
  var secondStyleGrid = document.getElementById('secondStyleGrid');
  var secondVariants = document.getElementById('secondVariants');
  var tier1PriceEl = document.querySelector('#bundleTiers .tier1-price');
  var tier2PriceEl = document.querySelector('#bundleTiers .tier2-price');
  var tier2Row = document.querySelector('.tier-option[data-tier="2"]');
  var saveBadge = document.getElementById('saveBadge');
  var addToCartBtn = document.getElementById('modalAddToCart');
  var modalStatus = document.getElementById('modalStatus');
  var preorderNote = document.querySelector('.preorder-note');
  var modalShipsBy = document.getElementById('modalShipsBy');

  var CATALOGS = {};
  document.querySelectorAll('script[data-ttk-catalog]').forEach(function (node) {
    try {
      var key = node.getAttribute('data-ttk-catalog');
      CATALOGS[key] = JSON.parse(node.textContent);
    } catch (e) { /* ignore malformed block */ }
  });

  var currentCategory = null;
  var currentProduct = null;
  var currentSize = null;
  var currentImageIndex = 0;
  var secondProduct = null;
  var secondSize = null;

  function productImages(product) {
    return (product.images && product.images.length) ? product.images : [product.image];
  }

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function firstAvailableSize(product) {
    var sizes = Object.keys(product.variants || {});
    for (var i = 0; i < sizes.length; i++) {
      if (product.variants[sizes[i]]) return sizes[i];
    }
    return sizes[0] || null;
  }

  function isSoldOut(product) {
    if (!product) return false;
    if (product.available === false) return true;
    var sizes = Object.keys(product.variants || {});
    return sizes.length > 0 && sizes.every(function (sz) { return !product.variants[sz]; });
  }

  function addToCartLabel() {
    if (!currentProduct) return 'Add to Cart';
    if (isSoldOut(currentProduct)) return 'Sold Out';
    return currentCategory && currentCategory.bundleEnabled ? 'Pre-Order' : 'Add to Cart';
  }

  // Tier-1 ("price for 1") always mirrors the currently-selected product's
  // live Shopify price — never a manually-entered number — so editing the
  // price in Shopify updates this automatically. Only the bundle's 2-for
  // price is merchant-set (that's a deliberate promo price, not a duplicate
  // of the product price).
  function updateBundleTierUI() {
    if (!currentCategory || !currentCategory.bundleEnabled || !currentProduct) return;
    tier1PriceEl.textContent = money(currentProduct.price);
    tier2PriceEl.textContent = money(currentCategory.priceTwo);
    saveBadge.textContent = 'Save ' + money(Math.max(0, (currentProduct.price * 2) - currentCategory.priceTwo));
  }

  window.openTTKProductModal = function (catalogKey, categoryKey) {
    var catalog = CATALOGS[catalogKey];
    if (!catalog || !catalog[categoryKey]) return false;
    currentCategory = catalog[categoryKey];
    if (!currentCategory.products || !currentCategory.products.length) return false;

    currentProduct = currentCategory.products[0];
    currentSize = firstAvailableSize(currentProduct);
    currentImageIndex = 0;
    secondProduct = currentCategory.products[1] || currentCategory.products[0];
    secondSize = firstAvailableSize(secondProduct);

    modalEyebrow.textContent = currentCategory.label || '';
    styleLabel.textContent = currentCategory.products.length > 1 ? 'Choose your jersey' : 'Style';

    renderMain();
    renderStyleGrid();
    renderSizes(modalVariants, currentSize, function (sz) { currentSize = sz; }, currentProduct);
    renderSecondPicker();

    var bundleTiers = document.getElementById('bundleTiers');
    if (currentCategory.bundleEnabled) {
      bundleTiers.style.display = '';
      updateBundleTierUI();
      var t1 = document.querySelector('input[name="bundleTier"][value="1"]');
      if (t1) t1.checked = true;
      secondItemPicker.classList.remove('show');
    } else {
      bundleTiers.style.display = 'none';
      secondItemPicker.classList.remove('show');
    }

    if (preorderNote) preorderNote.style.display = currentCategory.bundleEnabled ? '' : 'none';
    if (modalShipsBy) modalShipsBy.textContent = currentCategory.shipsBy || '';

    modalStatus.textContent = '';
    addToCartBtn.disabled = false;
    addToCartBtn.textContent = addToCartLabel();

    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    return true;
  };

  function renderMain() {
    var images = productImages(currentProduct);
    if (currentImageIndex >= images.length) currentImageIndex = 0;
    modalImage.src = images[currentImageIndex];
    modalImage.alt = currentProduct.title;
    modalTitle.textContent = currentProduct.title;
    var priceHtml = money(currentProduct.price);
if (currentProduct.compareAtPrice && currentProduct.compareAtPrice > currentProduct.price) {
  priceHtml += ' <span class="compare">' + money(currentProduct.compareAtPrice) + '</span>';
  var discountPercent = Math.round((currentProduct.compareAtPrice - currentProduct.price) / currentProduct.compareAtPrice * 100);
  priceHtml += ' <span class="ttk-sale-badge">SAVE ' + discountPercent + '%</span>';
}
    modalPrice.innerHTML = priceHtml;
    addToCartBtn.textContent = addToCartLabel();
    renderThumbs(images);
  }

  function renderThumbs(images) {
    modalThumbs.innerHTML = '';
    if (images.length <= 1) return;
    images.forEach(function (src, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = (i === currentImageIndex) ? 'selected' : '';
      btn.setAttribute('aria-label', currentProduct.title + ' image ' + (i + 1));
      btn.innerHTML = '<img src="' + src + '" alt="" loading="lazy">';
      btn.addEventListener('click', function () {
        currentImageIndex = i;
        modalImage.src = src;
        modalThumbs.querySelectorAll('button').forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
      });
      modalThumbs.appendChild(btn);
    });
  }

  function renderStyleGrid() {
    styleGrid.innerHTML = '';
    if (currentCategory.products.length <= 1) { styleGrid.style.display = 'none'; return; }
    styleGrid.style.display = 'flex';
    currentCategory.products.forEach(function (p) {
      var sw = document.createElement('button');
      sw.type = 'button';
      sw.className = 'style-swatch' + (p.id === currentProduct.id ? ' selected' : '');
      sw.title = p.title;
      sw.innerHTML = '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy">';
      sw.addEventListener('click', function () {
        currentProduct = p;
        currentImageIndex = 0;
        currentSize = firstAvailableSize(p);
        renderMain();
        renderSizes(modalVariants, currentSize, function (sz) { currentSize = sz; }, currentProduct);
        updateBundleTierUI();
        styleGrid.querySelectorAll('.style-swatch').forEach(function (x) { x.classList.remove('selected'); });
        sw.classList.add('selected');
      });
      styleGrid.appendChild(sw);
    });
  }

  function renderSizes(container, selected, onPick, product) {
    container.innerHTML = '';
    var group = document.createElement('div');
    group.className = 'variant-pills';
    var stockMap = product.stock || {};
    var badgesSuppressed = !!product.hideStockBadge;
    var sizes = Object.keys(product.variants || {});
    sizes.forEach(function (sz) {
      var pill = document.createElement('button');
      pill.type = 'button';
      var available = !!product.variants[sz];
      pill.className = 'variant-pill' + (sz === selected ? ' selected' : '');
      pill.textContent = sz;
      if (!available) pill.disabled = true;
      var status = badgesSuppressed ? null : stockMap[sz];
      if (available && (status === 'low' || status === 'few-left')) {
        var tag = document.createElement('span');
        tag.className = 'stock-tag';
        tag.innerHTML = status === 'low' ? '<span>LOW</span><span>STOCK</span>' : '<span>ONLY A</span><span>FEW LEFT</span>';
        pill.appendChild(tag);
      }
      pill.addEventListener('click', function () {
        if (pill.disabled) return;
        group.querySelectorAll('.variant-pill').forEach(function (x) { x.classList.remove('selected'); });
        pill.classList.add('selected');
        onPick(sz);
      });
      group.appendChild(pill);
    });
    container.appendChild(group);
  }

  function renderSecondPicker() {
    secondStyleGrid.innerHTML = '';
    currentCategory.products.forEach(function (p) {
      var sw = document.createElement('button');
      sw.type = 'button';
      sw.className = 'style-swatch' + (p.id === secondProduct.id ? ' selected' : '');
      sw.title = p.title;
      sw.innerHTML = '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy">';
      sw.addEventListener('click', function () {
        secondProduct = p;
        secondSize = firstAvailableSize(p);
        secondStyleGrid.querySelectorAll('.style-swatch').forEach(function (x) { x.classList.remove('selected'); });
        sw.classList.add('selected');
        renderSizes(secondVariants, secondSize, function (sz) { secondSize = sz; }, secondProduct);
      });
      secondStyleGrid.appendChild(sw);
    });

    // Visual "+" connector so it reads as "[jersey] + [free bracelet]" —
    // makes it obvious the bracelet comes with the bundle, not a 3rd product choice.
    var plus = document.createElement('span');
    plus.className = 'style-grid-plus';
    plus.setAttribute('aria-hidden', 'true');
    plus.textContent = '+';
    secondStyleGrid.appendChild(plus);

    // Static promo tile: reminds the shopper the 2nd-jersey bundle includes
    // a free dragon bracelet. Not a selectable product, just a visual cue.
    var braceletImg = secondStyleGrid.getAttribute('data-bracelet-image');
    var braceletLabel = secondStyleGrid.getAttribute('data-bracelet-label') || 'Free Dragon Bracelet';
    var promo = document.createElement('div');
    promo.className = 'style-swatch style-swatch--promo';
    promo.title = braceletLabel;
    promo.innerHTML = (braceletImg
      ? '<img src="' + braceletImg + '" alt="' + braceletLabel + '" loading="lazy">'
      : '<span class="promo-icon" aria-hidden="true">&#127873;</span>')
      + '<span class="promo-tag">FREE</span>';
    secondStyleGrid.appendChild(promo);

    renderSizes(secondVariants, secondSize, function (sz) { secondSize = sz; }, secondProduct);
  }

  document.querySelectorAll('input[name="bundleTier"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      secondItemPicker.classList.toggle('show', radio.value === '2' && radio.checked);
    });
  });

  function closeModal() {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    modalStatus.textContent = '';
  }

  var modalCloseBtn = document.getElementById('modalClose');
  if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  var sizeChartOverlay = document.getElementById('sizeChartOverlay');
  var sizeChartBtn = document.getElementById('sizeChartBtn');
  if (sizeChartOverlay && sizeChartBtn) {
    function openSizeChart() { sizeChartOverlay.classList.add('open'); sizeChartOverlay.setAttribute('aria-hidden', 'false'); }
    function closeSizeChart() { sizeChartOverlay.classList.remove('open'); sizeChartOverlay.setAttribute('aria-hidden', 'true'); }
    sizeChartBtn.addEventListener('click', openSizeChart);
    var sizeChartClose = document.getElementById('sizeChartClose');
    if (sizeChartClose) sizeChartClose.addEventListener('click', closeSizeChart);
    sizeChartOverlay.addEventListener('click', function (e) { if (e.target === sizeChartOverlay) closeSizeChart(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSizeChart(); });
  }

  /* ---------------- Add to cart: Shopify AJAX Cart API ---------------- */
  addToCartBtn.addEventListener('click', function () {
    var tierInput = document.querySelector('input[name="bundleTier"]:checked');
    var tier = (currentCategory.bundleEnabled && tierInput) ? tierInput.value : '1';

    var items = [];
    var firstVariantId = currentProduct.variants ? currentProduct.variants[currentSize] : null;
    if (!firstVariantId) {
      modalStatus.textContent = 'This size isn\u2019t available for ' + currentProduct.title + ' (' + currentSize + ').';
      return;
    }
    items.push({ id: firstVariantId, quantity: 1 });

    if (tier === '2') {
      var secondVariantId = secondProduct.variants ? secondProduct.variants[secondSize] : null;
      if (!secondVariantId) {
        modalStatus.textContent = 'This size isn\u2019t available for ' + secondProduct.title + ' (' + secondSize + ').';
        return;
      }
    items.push({ id: secondVariantId, quantity: 1 });
    items.push({ id: 53784870158699, quantity: 1 });
  }

    addToCartBtn.disabled = true;
    addToCartBtn.textContent = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) { throw new Error(err.description || 'Could not add to cart.'); });
        }
        return response.json();
      })
      .then(function () {
        refreshCartCount();
        var shipsBy = currentCategory.shipsBy ? (' \u2014 ships by ' + currentCategory.shipsBy) : '';
        var verb = currentCategory.bundleEnabled ? 'Pre-order added' : 'Added to cart';
        var msg = tier === '2'
          ? verb + ': ' + currentProduct.title + ' (' + currentSize + ') + ' + secondProduct.title + ' (' + secondSize + ')' + shipsBy + '.'
          : verb + ': ' + currentProduct.title + ' (' + currentSize + ')' + shipsBy + '.';
        modalStatus.textContent = msg;
        showCartToast(msg);
      })
      .catch(function (err) {
        modalStatus.textContent = err.message || 'Something went wrong adding this to your cart.';
      })
      .finally(function () {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = addToCartLabel();
      });
  });

  /* ---------------- Cart page: AJAX qty stepper + remove (no full reload) ---------------- */
  var cartItemsEl = document.querySelector('.cart-items');
  if (cartItemsEl) {
    var cartUpdating = false;

    function cartLineChange(key, quantity) {
      if (cartUpdating) return;
      cartUpdating = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          refreshCartCount();
          if (cart.item_count === 0) {
            window.location.reload();
            return;
          }
          return fetch(window.location.pathname + '?section_id=main')
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var newLayout = doc.querySelector('.cart-layout');
              var currentLayout = document.querySelector('.cart-layout');
              if (newLayout && currentLayout) {
                currentLayout.replaceWith(newLayout);
                bindCartRowEvents();
              }
            });
        })
        .catch(function () {
          showCartToast('Could not update your cart \u2014 please try again.');
        })
        .finally(function () { cartUpdating = false; });
    }

    function bindCartRowEvents() {
      document.querySelectorAll('.cart-qty-stepper').forEach(function (stepper) {
        var input = stepper.querySelector('.cart-qty-input');
        var key = input.name.replace('updates[', '').replace(']', '');
        var minus = stepper.querySelector('[data-cart-qty-decrement]');
        var plus = stepper.querySelector('[data-cart-qty-increment]');
        minus.addEventListener('click', function () {
          var v = Math.max(0, parseInt(input.value, 10) - 1);
          input.value = v;
          cartLineChange(key, v);
        });
        plus.addEventListener('click', function () {
          var v = parseInt(input.value, 10) + 1;
          input.value = v;
          cartLineChange(key, v);
        });
        input.addEventListener('change', function () {
          var v = Math.max(0, parseInt(input.value, 10) || 0);
          cartLineChange(key, v);
        });
      });
      document.querySelectorAll('[data-cart-remove-key]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          cartLineChange(btn.getAttribute('data-cart-remove-key'), 0);
        });
      });
    }
    bindCartRowEvents();
  }
})();
